<template>
    <a target="_blank" :href="helpCenterUrl">
        <slot />
    </a>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { resolveHelpCenterUrl } from '../shared/helpCenterResolver'

const store = useStore()
const helpCenterUrl = computed(() => resolveHelpCenterUrl(store.getters.lang))
</script>
